// src/config.js

const environments = {
  development: {
    apiBaseUrl: 'http://localhost:8787',
    appId: 'LNI-App',
    titleId: '70B8D', // Kept for backward compatibility
  },
  production: {
    apiBaseUrl: 'https://lni-backend.xrserver.workers.dev', // Replace with your actual Cloudflare Workers URL
    appId: 'LNI-App',
    titleId: '70B8D', // Kept for backward compatibility
  }
};

// Determine environment based on hostname
const isProduction = 
  window.location.hostname !== 'localhost' && 
  !window.location.hostname.includes('127.0.0.1');

const config = isProduction ? environments.production : environments.development;

export default config;
